import { AfterViewInit, Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { FormArray, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { ApiService } from '../../services/API/api.service';
import { AlertService } from '../../services/Alert/alert.service';
import { PaymentService } from '../../services/Payment/payment.service';
import { lastValueFrom } from 'rxjs';
import { HttpErrorResponse } from '@angular/common/http';

@Component({
  selector: 'app-checkout',
  templateUrl: './checkout.component.html',
  styleUrls: ['./checkout.component.scss']
})
export class CheckoutComponent implements OnInit {
  isEditing = false;
  originalAddress: any;
  addressForm!: FormGroup;
  informationDetailsForm!: FormGroup;
  isLoading: boolean = false;
  allAddresses: any[] = [];
  myAddresse: any
  addressesLength: number = 0
  guestMode: boolean = false;
  token: string = ''
  isGuestMode: string = ''
  mainAddress: any
  orderId: string = ''
  paymentMethod: string = '';

  couponValue: number = 0;
  couponCode: string = '';
  couponType: string = 'percentage';
  deliveyOption: string = ''

  checkoutFormWithToken: FormGroup;
  checkoutFormWithoutToken: FormGroup;

  constructor(
    private fb: FormBuilder, 
    private router: Router,
    private apiService: ApiService,
    private alertService: AlertService,
    // private paymentService: PaymentService
  ) {
    this.addressForm = this.fb.group({
      country_id: ['', Validators.required],
      city_id: ['', Validators.required],
      address: ['', Validators.required],
      building: [''],
      floor: [''],
      flat: [''],
      special_mark: [''],
      longitude: [''],
      latitude: ['']
    });

    this.token = localStorage.getItem('bbq_token')?.toString();
    this.isGuestMode = sessionStorage.getItem('guestMode');
    
    this.deliveyOption = localStorage.getItem('deliveryOption');
    if(!this.deliveyOption){
      localStorage.setItem('deliveryOption','delivery')
    }
  }

  changeDeliveryMethod(option: string){
    localStorage.setItem('deliveryOption',option)
    if(option == 'pickup'){
      this.checkoutFormWithToken.patchValue({
        deliveryMethod: 'pickup'
      })
      this.checkoutFormWithoutToken.patchValue({
        deliveryMethod: 'pickup'
      })
      this.delivery_fees = 0;
      this.setEmptyAddress()
    }else{
      this.checkoutFormWithToken.patchValue({
        deliveryMethod: 'delivery'
      })
      this.checkoutFormWithoutToken.patchValue({
        deliveryMethod: 'delivery'
      })
      this.setAddressReady()
      this.getTaxSetting()
      this.initAutocomplete()
    }
    this.calculateTotals();
  }

  setAddressReady(){
    this.addressForm.patchValue({
      address: '',
      longitude: '',
      latitude: '',
      country_id: null,
      city_id: null,
    })
    setTimeout(() => {
      $('#addressForm').removeClass('d-none')
      $('#addressForm').addClass('d-block')
    }, 500);
  }
  setEmptyAddress(){
    this.addressForm.patchValue({
      address: '-',
      longitude: '1',
      latitude: '1',
      country_id: 1,
      city_id: 1,
    })
  }

  async ngOnInit(): Promise<void> {
    this.paymentMethod = localStorage.getItem('paymentMethod')
    this.initializeForm();
    this.initiaseCheckoutForm()
    this.allCountriesFunction()
    const token = localStorage.getItem('bbq_token')?.toString();
    const guestMode = sessionStorage.getItem('guestMode');
    if(token){
      this.myAddressesFunction()
      this.loadMyProfileDetails()
    }else if(guestMode){
      this.guestMode = true;
      this.loadGuestAddresses();
    }else{
      this.alertService.danger('You must be logged in or continue as a guest to start the checkout process');
    }
    this.initAutocomplete()
    this.initAutocomplete2()
    this.couponApplyFunction()
    // this.paymentService.loadAcceptJs();
    this.getTaxSetting()
  }

  initiaseCheckoutForm() {
    this.checkoutFormWithToken = this.fb.group({
      vendor: this.fb.group({
        id: [1, Validators.required],
        name: ['wings_bayonnebbq', Validators.required],
        avatar: ['avatar.png']
      }), // done
      products: this.fb.array([], Validators.required), // done
      address: ['', Validators.required], // done
      deliveryPhone: ['', [Validators.required, Validators.pattern(/^\+?[0-9]{10,15}$/)]],
      payMethod: [this.paymentMethod, Validators.required], // done
      deliveryMethod: ['', Validators.required], // done
      deliveryNote: [''],
      delivery_tips: [0, [Validators.min(0)]],
      longitude: [''], // done
      latitude: [''], // done
      totalCost: [0, [Validators.required, Validators.min(0)]],
      copon_id: ['']
    });

    this.checkoutFormWithoutToken = this.fb.group({
      vendor: this.fb.group({
        id: [1, Validators.required],
        name: ['wings_bayonnebbq', Validators.required],
        avatar: ['avatar.png']
      }), // done
      products: this.fb.array([], Validators.required), // done
      address: ['', Validators.required], // done
      deliveryPhone: ['', [Validators.required, Validators.pattern(/^\+?[0-9]{10,15}$/)]],
      payMethod: [this.paymentMethod, Validators.required], // done
      deliveryMethod: ['', Validators.required], // done
      deliveryNote: [''],
      delivery_tips: [0, [Validators.min(0)]],
      longitude: [''], // done
      latitude: [''], // done
      totalCost: [0, [Validators.required, Validators.min(0)]],
      copon_id: [''],
      fullname: ['', [Validators.required]],
      email: ['', [Validators.required, Validators.email]]
    });

    const addressIsSet = localStorage.getItem('selectedAddress');
    if(addressIsSet){
      this.checkoutFormWithToken.patchValue({
        address: localStorage.getItem('selectedAddress'),
        longitude: localStorage.getItem('selectedLng'),
        latitude: localStorage.getItem('selectedLat')
      })
    }
  }

  couponApplyFunction(){
    const couponApplied = localStorage.getItem('couponApplied');
    if(couponApplied){
      this.couponApplied = true;
      this.couponValue = parseFloat(localStorage.getItem('couponValue'));
      this.couponCode = localStorage.getItem('couponCode');
      this.couponType = localStorage.getItem('couponType');
      this.calculateTotals();
    }
  }

  initializeForm(): void {
    this.informationDetailsForm = this.fb.group({
      fullname: ['', [Validators.required]],
      phoneNumber: ['', [Validators.required, Validators.pattern(/^\+?[0-9]{10,15}$/)]], //Validators.pattern(/^[\+]?[(]?[0-9]{3}[)]?[-\s\.]?[0-9]{3}[-\s\.]?[0-9]{4}$/)
      email: ['', [Validators.required, Validators.email]],
      note: ['']
    });
  }

  allCountries: any
  countriesLength: number = 0
  selectedCountryId: number | null = null;
  cities: any[] = [];
  citySelected: boolean = false;
  setNewAddress: boolean = false;
  allCountriesFunction(){
    // this.isLoading = true;
    this.apiService.countries(1).subscribe({
      next: response => {
        this.allCountries = response.data;
        this.countriesLength = this.allCountries.length;
        // this.isLoading = false;
      }, 
      error: (error: any) => {
        this.alertService.danger(error.error.message);
        this.allCountries = [];
        // this.isLoading = false;
      }
    });
  }
  onCountryChange(countryId: any) {
    this.selectedCountryId = countryId.value;
    const selectedCountry = this.allCountries.find(c => c.id == this.selectedCountryId);
    this.cities = selectedCountry ? selectedCountry.cities : [];
    // this.newinformationDetailsForm.get('city_id')?.reset();
    this.citySelected = true;
  }
  myAddressesFunction(){
    this.isLoading = true;
    this.apiService.myAddresses().subscribe({
      next: response => {
        this.myAddresse = response.data.myAddresses[0].address;
        this.allAddresses = response.data.myAddresses;
        this.addressesLength = response.data.myAddresses.length;
        this.isLoading = false;
        this.mainAddressSets()
      }, 
      error: (error: any) => {
        this.alertService.danger(error.error.message);
        this.allAddresses = [];
        this.isLoading = false;
      }
    });
  }
  setAsMain(addressId: number): void {
    if (this.isLoading) return;
    
    // Find if there's already a main address
    const currentMainAddress = this.allAddresses?.find(a => a.isMain);
    
    // Prevent unnecessary API call if already main
    if (currentMainAddress && currentMainAddress.id === addressId) {
      this.alertService.danger('This is already your main address');
      return;
    }

    this.isLoading = true;
    this.apiService.setMainAddress(addressId).subscribe({
      next: () => {
        // Update UI optimistically
        this.allAddresses = this.allAddresses?.map(address => ({
          ...address,
          isMain: address.id === addressId
        })) || null;
        // this.extraData.owner.address.line1 = this.allAddresses[0].address;
        
        this.alertService.success('Main address updated successfully');
        this.isLoading = false;
        this.mainAddressSets()
      },
      error: (error) => {
        this.alertService.danger(error.error?.message || 'Failed to update main address');
        this.isLoading = false;
      }
    });
  }
  deleteAddress(addressId: number): void {
    if (confirm('Are you sure you want to delete this address?')) {
      this.apiService.deleteAddress(addressId).subscribe({
        next: () => {
          this.alertService.success('Address deleted successfully');
          this.myAddressesFunction(); // Refresh the list
        },
        error: (error) => {
          this.alertService.danger(error.error?.message || 'Failed to delete address');
        }
      });
    }
  }
  addNewAddress(){
    this.setNewAddress = !this.setNewAddress;
    if(this.setNewAddress){
      $('#addressForm').removeClass('d-none')
      $('#addressForm').addClass('d-block')
      $('#AddNewAddress').text('Remove Adding');
    }else{
      $('#addressForm').removeClass('d-block')
      $('#addressForm').addClass('d-none')
      $('#AddNewAddress').text('Add New Address')
    }
  }

  saveAddress(): void {
    if (this.informationDetailsForm.valid) {
      this.isEditing = false;
      this.informationDetailsForm.disable();
      // Here you would typically send the data to your backend
    }
  }

  cancelEdit(): void {
    this.isEditing = false;
    this.informationDetailsForm.patchValue(this.originalAddress);
    this.informationDetailsForm.disable();
  }
  profileDetails: any
  loadMyProfileDetails(){
    this.apiService.myProfile().subscribe({
      next: response => {
        this.profileDetails = response.data;
        this.informationDetailsForm.patchValue({
          fullname: this.profileDetails.name,
          phoneNumber: this.profileDetails.phone,
          email: this.profileDetails.email
        })
      }, 
      error: (error: any) => {
        this.alertService.danger(error.error.message);
      }
    });
  }

  

  get subtotal(): number {
    return this.cartItems.reduce((sum, item) => sum + (item.price * item.quantity), 0);
  }

  private _discount: number = 0;

  // get discount(): number {
  //   return this.couponApplied ? this.subtotalCart * 0.06 : 0;
  // }


  get total(): number {
    return this.subtotal - this.discount;
  }

  // updateQuantity(item: CartItem, change: number): void {
  //   const newQuantity = item.quantity + change;
  //   if (newQuantity >= 1) {
  //     item.quantity = newQuantity;
  //   }
  // }
  phoneNumber: string = ''
  note: string = ''
  isLoadingPlaceOrder: boolean = false
  placeOrder(): void {
    if(this.paymentMethod == 'cash' || this.paymentMethod == 'Cash'){
      this.placeOrderWithCash()
      return;
    }
    if(this.deliveyOption == 'pickup'){
      this.setEmptyAddress()
    }
    const number = this.phoneNumber.replace(/\D/g, '');
    this.isLoadingPlaceOrder = true
    this.checkoutFormWithToken.patchValue({
      deliveryNote: this.note,
      deliveryPhone: number,
      copon_id: localStorage.getItem('couponId'),
      deliveryMethod: localStorage.getItem('deliveryOption')
    })
    // this.mainAddress = this.mainAddress.map( address => address.isMain == true )
    const token = localStorage.getItem('bbq_token')?.toString();
    if(token){
      this.checkoutFormWithToken.patchValue({
        address: this.mainAddress.address,
        longitude: this.mainAddress.longitude,
        latitude: this.mainAddress.latitude
      })
    }
    this.informationDetailsForm.markAllAsTouched();
    // console.log(this.checkoutFormWithToken.value)
    if(this.checkoutFormWithToken.valid){
      this.apiService.confirmOrder(this.checkoutFormWithToken.value).subscribe({
        next: (response) => {
          this.orderId = response.data.id;
          this.alertService.success(response.message);
          const url = response.data.url;
          window.location.href = url
          // localStorage.removeItem('couponId');
          // localStorage.removeItem('couponType');
          // localStorage.removeItem('couponValue');
          // localStorage.removeItem('couponCode');

          // this.updatePaymentState("success");
          // this.apiService.emptyCart().subscribe({});
          // this.cartItems = [];
          // this.router.navigate(['/order-success']);
        }, 
        error: (error) => {
          this.alertService.danger(error.error.message);
          this.isLoadingPlaceOrder = false
        }
      });
    }else{
        this.alertService.danger('Please fill card details');
        this.isLoadingPlaceOrder = false
    }
  }

  dataSubmittedSuccessfully: boolean = false;
  placeOrderWithoutToken(): void {
    this.isLoadingPlaceOrder = true
    if(this.paymentMethod == 'cash' || this.paymentMethod == 'Cash'){
      this.placeOrderWithoutTokenWithCash()
      return;
    }
    if(this.deliveyOption == 'pickup'){
      this.setEmptyAddress()
    }
    this.checkoutFormWithoutToken.patchValue({
      deliveryNote: this.informationDetailsForm.get('note')?.value,
      deliveryPhone: this.informationDetailsForm.get('phoneNumber')?.value,
      fullname: this.informationDetailsForm.get('fullname')?.value,
      email: this.informationDetailsForm.get('email')?.value,
      copon_id: localStorage.getItem('couponId'),
      address: this.addressForm.get('address')?.value,
      longitude: this.addressForm.get('longitude')?.value,
      latitude: this.addressForm.get('latitude')?.value,
      deliveryMethod: localStorage.getItem('deliveryOption')
    })
    console.log(this.checkoutFormWithoutToken.value)
    if(this.isGuestMode && this.checkoutFormWithoutToken.valid){
        this.apiService.confirmOrderWithoutToken(this.checkoutFormWithoutToken.value).subscribe({
          next: (response) => {
            this.orderId = response.data.id;
            this.alertService.success(response.message);
            this.dataSubmittedSuccessfully = true;
            const url = response.data.url;
            window.location.href = url
            // localStorage.removeItem('couponId');
            // localStorage.removeItem('couponType');
            // localStorage.removeItem('couponValue');
            // localStorage.removeItem('couponCode');
            // this.updatePaymentState("success");
            // sessionStorage.removeItem('cartItems');
            // this.cartItems = [];
            // this.router.navigate(['/order-success']);
          }, 
          error: (error) => {
            this.dataSubmittedSuccessfully = false;
            this.alertService.danger(error.error.message);
            this.isLoadingPlaceOrder = false
          }
        });
    }else{
      if(this.checkoutFormWithoutToken.get('address')?.value == "" || 
        this.checkoutFormWithoutToken.get('longitude')?.value == "" || 
        this.checkoutFormWithoutToken.get('latitude')?.value == "" || 
        this.checkoutFormWithoutToken.get('deliveryPhone')?.value == "" || 
        this.checkoutFormWithoutToken.get('payMethod')?.value == "" || 
        this.checkoutFormWithoutToken.get('deliveryMethod')?.value == "" || 
        this.addressForm.get('country_id')?.value == "" || 
        this.addressForm.get('city_id')?.value == ""){
          this.alertService.danger('Please fill all required fields');
      }
      this.isLoadingPlaceOrder = false
    }
  }

  // tips section
  tipPercentages = [15, 20, 25, 30];
  selectedTip: number | 'custom' | null = null;
  customTipAmount: number | null = null;

  selectTip(percent: number) {
    this.selectedTip = percent;
    this.customTipAmount = null;
    this.calculateTotals()
  }

  selectCustomTip() {
    this.selectedTip = 'custom';
    setTimeout(() => {
      const input = document.querySelector('.custom-tip-input') as HTMLInputElement;
      input?.focus();
    }, 0);
    this.calculateTotals()
  }

  resetTips() {
    this.selectedTip = null;
    this.customTipAmount = null;
  }

  getSelectedTipValue(): number | null {
    if (this.selectedTip === 'custom') {
      return this.customTipAmount;
    }
    return this.selectedTip;
  }

  // map
  autocomplete!: google.maps.places.Autocomplete;
  autocomplete2!: google.maps.places.Autocomplete;
  selectedLat: number = 0;
  selectedLng: number = 0;
  placeName: string = '';
  private bayonneDeliveryZone = [
    {lat:40.642, lng:-74.148},
    {lat:40.650, lng:-74.086},
    {lat:40.727, lng:-74.020},
    {lat:40.737, lng:-74.086},
    {lat:40.642, lng:-74.148}
  ];
  initAutocomplete(): void {
    setTimeout(() => {
      if(this.deliveyOption == 'delivery'){
      const input = document.getElementById('addressInput1') as HTMLInputElement;
      this.autocomplete = new google.maps.places.Autocomplete(input, {
        componentRestrictions: { country: 'us' },
        fields: ['geometry', 'formatted_address', 'address_components']
      });

      this.autocomplete.addListener('place_changed', async () => {
        const place = this.autocomplete.getPlace();
        if (!place.geometry) {
          this.alertService.danger('Please select a valid address from the suggestions');
          return;
        }

        // Corrected condition with proper parentheses
        const inBayonne = place.address_components?.some(comp => 
          (comp.types.includes('locality') && ['Bayonne'].includes(comp.long_name)) ||
          (comp.types.includes('postal_code') && ['07002', '07305', '07304'].some(zip => comp.long_name.startsWith(zip))
        ));
        if (!inBayonne) {
          this.handleOutOfZone(input);
          return;
        }

        const location = place.geometry.location;
        const isInZone = await this.checkDeliveryZone(location.lat(), location.lng());
        
        if (!inBayonne) { //isInZone
          this.handleOutOfZone(input);
        } else {
          this.selectedLat = location.lat();
          this.selectedLng = location.lng();
          this.placeName = place.formatted_address;
          localStorage.setItem('selectedAddress', this.placeName);
          localStorage.setItem('selectedLat', location.lat().toString());
          localStorage.setItem('selectedLng', location.lng().toString());
          this.addressForm.patchValue({
            address: this.placeName,
            longitude: this.selectedLng.toString(),
            latitude: this.selectedLat.toString()
          });
        }
      });
    }
    }, 400);
  }
  initAutocomplete2(): void {
    const input = document.getElementById('billingAddress') as HTMLInputElement;
    this.autocomplete2 = new google.maps.places.Autocomplete(input, {
      componentRestrictions: { country: 'us' },
      fields: ['geometry', 'formatted_address', 'address_components']
    });

    this.autocomplete2.addListener('place_changed', async () => {
      const place = this.autocomplete2.getPlace();
      if (!place.geometry) {
        this.alertService.danger('Please select a valid address from the suggestions');
        return;
      }

      // const location = place.geometry.location;
      // const isInZone = await this.checkDeliveryZone(location.lat(), location.lng());
      
      
      // this.selectedLat = location.lat();
      // this.selectedLng = location.lng();
      // this.placeName = place.formatted_address;
      // this.addressForm.patchValue({
      //   address: this.placeName,
      //   longitude: this.selectedLng.toString(),
      //   latitude: this.selectedLat.toString()
      // });
    });
  }
  private handleOutOfZone(input: HTMLInputElement): void {
    this.alertService.danger('Sorry, we only deliver within Bayonne, NJ');
    this.addressForm.patchValue({
      address: '',
      longitude: null,
      latitude: null
    });
    input.value = '';
    this.selectedLat = null;
    this.selectedLng = null;
    this.placeName = '';
  }
  private isPointInPolygon(point: {lat: number, lng: number}, polygon: any[]): boolean {
    // Ray-casting algorithm
    let inside = false;
    for (let i = 0, j = polygon.length - 1; i < polygon.length; j = i++) {
      const xi = polygon[i].lat, yi = polygon[i].lng;
      const xj = polygon[j].lat, yj = polygon[j].lng;
      
      const intersect = ((yi > point.lng) !== (yj > point.lng)) &&
        (point.lat < (xj - xi) * (point.lng - yi) / (yj - yi) + xi);
      if (intersect) inside = !inside;
    }
    return inside;
  }
  async checkDeliveryZone(lat: number, lng: number): Promise<boolean> {
    
    const inBounds = this.isInBayonneBounds(lat, lng);
    
    const inPolygon = this.isPointInPolygon({lat, lng}, this.bayonneDeliveryZone);
    
    return inPolygon;
  }
  private isInBayonneBounds(lat: number, lng: number): boolean {
    // Simple rectangular bounds check first for performance
    return (
      lat >= 40.6412 && // Southern boundary
      lat <= 40.6689 && // Northern boundary
      lng >= -74.1147 && // Western boundary
      lng <= -74.0279   // Eastern boundary
    );
  }

  submitAddress() {
    if (this.addressForm.invalid) {
      this.addressForm.markAllAsTouched();
      this.alertService.danger('Please fill all required fields');
      return;
    }

    const address: any = {
      city_id: this.addressForm.value.city_id,
      address: this.addressForm.value.address,
      latitude: this.addressForm.value.latitude,
      longitude: this.addressForm.value.longitude
    };

    // Only add optional fields if they have values
    if (this.addressForm.value.building) {
      address.building = this.addressForm.value.building;
    }
    if (this.addressForm.value.floor) {
      address.floor = this.addressForm.value.floor;
    }
    if (this.addressForm.value.flat) {
      address.flat = this.addressForm.value.flat;
    }
    if (this.addressForm.value.special_mark) {
      address.special_mark = this.addressForm.value.special_mark;
    }

    this.isLoading = true;
    this.apiService.addAddress(address).subscribe({
      next: (response) => {
        this.alertService.success(response.message);
        this.myAddressesFunction(); // Refresh addresses list
        this.addressForm.reset();
        this.isLoading = false;
      },
      error: (error) => {
        this.alertService.danger(error.error?.message || 'Failed to add address');
        this.isLoading = false;
      }
    });
  }

  mainAddressSets(){
    const addressSelected = this.allAddresses.find(address => address.isMain == true);
    this.mainAddress = addressSelected;
  }

  taxValue: number = 0;
  taxType: string = '';
  feeValue: number = 0;
  feeType: string = '';
  delivery_fees: number = 0;
  settings: any = {};
  getTaxSetting(){
    this.apiService.vendorSettings().subscribe({
      next: response => {
        this.taxValue = response.settings.tax_value;
        this.taxType = response.settings.tax_type;
        this.feeValue = parseFloat(response.settings.fee_value);
        this.feeType = response.settings.fee_type;
        this.settings = response.settings;

        const isOpen = response.settings.is_open;
        if(isOpen == false){
          this.alertService.danger('This vendor is currently closed.');
          setTimeout(() => {
            this.router.navigate(['/out-of-service']);
          }, 1000);
        }

        if(this.token){
          this.getCartItems()
        }else if(this.isGuestMode){
          this.loadGuestCart();
          this.calculateDeliveryFees();
          // if (this.cartItems.length > 0) {
          //   // Check if any item has categoryName equal to 'Catering'
          //   const hasCateringItem = this.cartItems.some(item => item.category_name == 'Catering');  
          //   console.log('hasCateringItem: ' + hasCateringItem);
          //   if (hasCateringItem) {
          //     console.log('Catering items found');
          //     this.delivery_fees = parseFloat(response.settings.catering_delivery_fees);
          //   } else {
          //     console.log('No catering items found');
          //     this.delivery_fees = parseFloat(response.settings.delivery_fees);
          //   }
            
          //   if (this.deliveyOption == 'pickup') {
          //     this.delivery_fees = 0;
          //   }
          // }
        }
      }, 
      error: (error: any) => {
      }
    });
  }

  calculateDeliveryFees() {
    this.delivery_fees = 0;
    if (this.cartItems.length > 0) {
      // Check if any item has categoryName equal to 'Catering'
      const hasCateringItem = this.cartItems.some(item => item.category_name == 'Catering');  
      if (hasCateringItem) {
        this.delivery_fees = parseFloat(this.settings.catering_delivery_fees);
      } else {
        // console.log('No catering items found');
        this.delivery_fees = parseFloat(this.settings.delivery_fees);
      }
      const option = localStorage.getItem('deliveryOption')
      if(option == 'pickup'){
        this.delivery_fees = 0;
      }
    }
  }

  loadGuestCart() {
    this.isLoading = true;
    const cartItems = sessionStorage.getItem('cartItems');
    if (cartItems) {
      this.cartItems = JSON.parse(cartItems);
      this.cartItems = this.cartItems;
      this.cartItems.forEach(item => {
        // Prepare extras in the required format
        const extras = item.selectedExtraId && Array.isArray(item.selectedExtraId) 
            ? item.selectedExtraId.map(extra => ({
                name: extra.name,
                quantity: extra.quantity,
                price: extra.price
            }))
            : [];

        // Prepare sides in the required format
        const sides = item.selectedFreeSides && Array.isArray(item.selectedFreeSides)
            ? item.selectedFreeSides.map(side => ({
                id: side.id,
                name: side.name,
                price: side.price
            }))
            : [];

        this.addProduct({
            name: item.name,
            type: item.selectedTypeId ? 
                item.types.find((t: any) => t.id === item.selectedTypeId)?.name : 
                item.types[0]?.name || '',
            quantity: item.quantity,
            price: item.types.find((t: any) => t.id === item.selectedTypeId)?.price, // Calculate price including extras and sides  this.getItemPrice(item)
            avatar: item.avatar,
            extras: extras, // Add extras as array of objects
            sides: sides    // Add sides as array of objects
        });
      });
      this.cartItemsLength = this.cartItems.length;
      this.calculateTotals();
      if(cartItems.length == 0){
        this.alertService.danger('Please choose at least one item to proceed');
        this.router.navigate(['/menu']);
      }
    }else{
      this.alertService.danger('Please choose at least one item to proceed');
      this.router.navigate(['/menu']);
    }
    this.isLoading = false;
  }

  addCartItemsToForm() {
    // Clear any existing products from BOTH forms first
    const productsArrayWithToken = this.checkoutFormWithToken.get('products') as FormArray;
    const productsArrayWithoutToken = this.checkoutFormWithoutToken.get('products') as FormArray;
    
    productsArrayWithToken.clear();
    productsArrayWithoutToken.clear();
    
    // Use a Map to track unique product combinations
    const uniqueProducts = new Map();
    
    this.cartItems.forEach(item => {
        // Create a unique key based on all distinguishing properties
        const key = this.generateProductKey(item);
        
        // Prepare extras in the required format
        const extras = item.selectedExtraId && Array.isArray(item.selectedExtraId) 
            ? item.selectedExtraId.map(extra => ({
                name: extra.name,
                quantity: extra.quantity,
                price: extra.price
            }))
            : [];

        // Prepare sides in the required format
        const sides = item.selectedFreeSides && Array.isArray(item.selectedFreeSides)
            ? item.selectedFreeSides.map(side => ({
                id: side.id,
                name: side.name,
                price: side.price
            }))
            : [];

        const productType = item.selectedTypeId ? 
            item.types.find((t: any) => t.id === item.selectedTypeId)?.name : 
            item.types[0]?.name || '';

        const productPrice = item.types.find((t: any) => t.id === item.selectedTypeId)?.price;

        if (uniqueProducts.has(key)) {
            // If identical product exists, increase quantity
            const existingProduct = uniqueProducts.get(key);
            existingProduct.quantity += item.quantity;
        } else {
            // Add new unique product
            uniqueProducts.set(key, {
                name: item.name,
                type: productType,
                quantity: item.quantity,
                price: productPrice,
                avatar: item.avatar,
                extras: extras,
                sides: sides
            });
        }
    });
    
    // Add all unique products to the form
    uniqueProducts.forEach(product => {
        this.addProduct(product);
    });
    
    console.log('Final products without duplication:', uniqueProducts);
  }

  // Helper function to generate unique key for product combination
  generateProductKey(item: any): string {
    // Sort sides and extras to ensure consistent ordering
    const sortedSides = item.selectedFreeSides && Array.isArray(item.selectedFreeSides)
        ? [...item.selectedFreeSides].sort((a, b) => a.id - b.id).map(side => side.id).join(',')
        : '';

    const sortedExtras = item.selectedExtraId && Array.isArray(item.selectedExtraId)
        ? [...item.selectedExtraId].sort((a, b) => a.id - b.id).map(extra => `${extra.id}:${extra.quantity}`).join(',')
        : '';

    return `${item.name}-${item.selectedTypeId}-[${sortedSides}]-[${sortedExtras}]`;
  }

  // Modified addProduct function
  addProduct(product: {
      name: string,
      type: string,
      quantity: number,
      price: number,
      avatar: string,
      extras: any[],
      sides: any[]
  }) {
      const productGroup = this.fb.group({
          name: [product.name, Validators.required],
          type: [product.type, Validators.required],
          quantity: [product.quantity, [Validators.required, Validators.min(1)]],
          price: [product.price, [Validators.required, Validators.min(0)]],
          avatar: [product.avatar],
          extras: [product.extras],
          sides: [product.sides]
      });
      
      (this.checkoutFormWithToken.get('products') as FormArray).push(productGroup);
      (this.checkoutFormWithoutToken.get('products') as FormArray).push(productGroup);
  }

  // cart functions
  // paymentMethod: string = 'Card';
  // couponCode: string = '';
  // isLoading: boolean = false;
  cartItems: any[] = [];
  cartItemsLength: number = 0;
  subtotalCart: number = 0;
  totalCart: number = 0;
  couponApplied: boolean = false;
  couponDiscount: number = 0;
  getCartItems() {
    this.isLoading = true;
    this.apiService.getCart().subscribe({
      next: response => {
        this.cartItems = response.data;
        this.cartItemsLength = this.cartItems.length;
        setTimeout(() => {
          this.calculateDeliveryFees();
          this.calculateTotals();
        }, 500);
        this.isLoading = false;
        this.addCartItemsToForm();
        if(this.cartItemsLength == 0){
          this.alertService.danger('Please choose at least one item to proceed');
          this.router.navigate(['/menu']);
        }
      }, 
      error: (error: any) => {
        this.alertService.danger(error.error.message);
        this.isLoading = false;
      }
    });
  }
  calculateTotals() {
    // Remove setTimeout - it's not needed and can cause issues
    this.calculateSubtotal();
    this.calculateTax();
    this.calculateFee()
    this.calculateTip();
    setTimeout(() => {
      this.calculateFinalTotal();
    }, 500);
    
    // console.log('Subtotal:', this.subtotalCart);
    // console.log('Tax:', this.taxAmount);
    // console.log('Tip:', this.tipAmount);
    // console.log('Discount:', this.discount);
    // console.log('Delivery:', this.delivery_fees , typeof(this.delivery_fees));
    // console.log('Total:', this.totalCart);
  }
  taxAmount: number = 0;
  feeAmount: number = 0;
  tipAmount: number = 0;
  // private calculateSubtotal() {
  //   this.subtotalCart = this.cartItems.reduce((sum, item) => {
  //     const itemPrice = this.getItemPrice(item);
  //     const quantity = item.quantity || 0; // Ensure quantity is a number
  //     return sum + (itemPrice * quantity);
  //   }, 0);
  // }
  discountFromOffers: number = 0; 
  private calculateSubtotal() {
    this.subtotalCart = this.cartItems.reduce((sum, item) => {
        const itemPrice = this.getItemPrice(item); // This now considers offers
        const quantity = item.quantity || 0;
        return sum + (itemPrice * quantity);
    }, 0);
    
    // Calculate total discount from offers
    this.discountFromOffers = this.cartItems.reduce((sum, item) => {
        if (item.offer) {
            const originalPrice = this.getOriginalItemPrice(item);
            const discountedPrice = this.getItemPrice(item);
            return sum + ((originalPrice - discountedPrice) * item.quantity);
        }
        return sum;
    }, 0);
}


  private calculateTax() {
    if (this.taxType === 'fixed') {
      this.taxAmount = this.taxValue || 0;
    } else {
      const taxPercentage = this.taxValue || 0;
      this.taxAmount = this.subtotalCart * (taxPercentage / 100);
      // console.log(this.taxAmount)
    }
  }

  private calculateFee() {
    if (this.feeType === 'fixed') {
      this.feeAmount = this.feeValue || 0;
    } else {
      const feePercentage = this.feeValue || 0;
      this.feeAmount = this.subtotalCart * (feePercentage / 100);
    }
  }

  // private calculateTip() {
  //   if (!this.selectedTip) {
  //     this.tipAmount = 0;
  //     return;
  //   }

  //   if (this.selectedTip === 'custom' && this.customTipAmount) {
  //     this.tipAmount = this.subtotalCart * ((this.customTipAmount || 0));
  //   } else if (typeof this.selectedTip === 'number') {
  //     this.tipAmount = this.subtotalCart * (this.selectedTip / 100);
  //   } else {
  //     this.tipAmount = 0;
  //   }
  // }
  private calculateTip() {
    if (!this.selectedTip) {
      this.tipAmount = 0;
      return;
    }

    if (this.selectedTip === 'custom' && this.customTipAmount) {
      // Use customTipAmount directly as a fixed amount instead of percentage
      this.tipAmount = this.customTipAmount || 0;
    } else if (typeof this.selectedTip === 'number') {
      // Still use percentage for predefined tips
      this.tipAmount = this.subtotalCart * (this.selectedTip / 100);
    } else {
      this.tipAmount = 0;
    }
  }


  // private calculateFinalTotal() {
    
  //   this.totalCart = this.subtotalCart + 
  //                   (this.taxAmount || 0) + 
  //                   (this.feeAmount || 0) + 
  //                   (this.tipAmount || 0) + 
  //                   (this.delivery_fees || 0) - 
  //                   (this.discount || 0);

    
  //   this.checkoutFormWithToken.patchValue({
  //     totalCost: this.totalCart,
  //     delivery_tips: this.tipAmount || 0
  //   });

  //   if(this.isGuestMode){
  //     this.checkoutFormWithoutToken.patchValue({
  //       totalCost: this.totalCart,
  //       delivery_tips: this.tipAmount || 0
  //     });
  //   }

  //   console.log(this.checkoutFormWithToken.value)
  //   // Ensure total is never negative
  //   // this.totalCart = Math.max(0, this.totalCart);
  //   console.log('Total:', this.totalCart);
  // }

  get discount(): number {
    // console.log(this.couponType)
    if(this.couponType == 'percentage'){
      return this.couponApplied ? this.subtotalCart * this.couponValue / 100 : 0;
    }else if(this.couponType == 'value'){
      // console.log(this.subtotalCart - this.couponValue)
      return this.couponValue;
    }
    // return this.couponApplied ? this.subtotalCart * this.couponValue : 0;
  }

// Helper function to get just the extras total
getExtrasTotal(item: any): number {
    let extrasPrice = 0;
    if (item.selectedExtraId && Array.isArray(item.selectedExtraId) && item.extraproducts) {
        const extraQuantities = new Map<number, number>();
        
        if (item.selectedExtraId.length > 0 && typeof item.selectedExtraId[0] === 'number') {
            item.selectedExtraId.forEach((id: number) => {
                extraQuantities.set(id, (extraQuantities.get(id) || 0) + 1);
            });
        } else {
            item.selectedExtraId.forEach((extraObj: any) => {
                const id = extraObj.id;
                extraQuantities.set(id, (extraQuantities.get(id) || 0) + 1);
            });
        }
        
        extraQuantities.forEach((quantity, extraId) => {
            const extra = item.extraproducts.find((e: any) => e.id === extraId);
            if (extra && extra.price) {
                extrasPrice += extra.price * quantity;
            }
        });
    }
    return extrasPrice;
}

  getExtraName(item: any, extraId: number): string {
  try {
    // First try to find in item.extra array
    if (item && item.extra && Array.isArray(item.extra)) {
      const extra = item.extra.find((e: any) => e.id == extraId);
      if (extra && extra.name) {
        return extra.name;
      }
    }
    
    // Fallback: try item.extraproducts (if it exists)
    if (item && item.extraproducts && Array.isArray(item.extraproducts)) {
      const extra = item.extraproducts.find((e: any) => e.id == extraId);
      if (extra && extra.name) {
        return extra.name;
      }
    }
    
    // Final fallback
    return `Extra #${extraId}`;
  } catch (error) {
    console.error('Error getting extra name:', error);
    return 'Extra';
  }
}

  getOfferText(item: any): string {
    if (!item.offer) return '';
    
    if (item.offer.type === 'discount') {
        return `Save $${item.offer.value}`;
    }
    else if (item.offer.type === 'percentage') {
        return `${item.offer.value}% OFF`;
    }
    
    return '';
  }

  loadGuestAddresses(){
    this.guestMode = true;
    setTimeout(() => {
      $('#addressForm').removeClass('d-none')
      $('#addressForm').addClass('d-block')
    }, 400);
    const selectedAddress = localStorage.getItem('selectedAddress');
    if(selectedAddress){
      this.addressForm.patchValue({
        address: selectedAddress,
        longitude: localStorage.getItem('selectedLng'),
        latitude: localStorage.getItem('selectedLat')
      })
    }
  }

  // payment method functions
  paymentData = {
    cardHolderName: '',
    cardNumber: '',
    expirationDate: '',
    cardCode: '',
    billingAddress: ''
  };
  showAddress(event: any): void {
    // console.log(event.target.value)
  }

  // async submitPayment() {
  //   console.log(this.checkoutFormWithToken.value)
  //   // this.isLoadingPlaceOrder = true
  //   const deliv = localStorage.getItem('deliveryOption');
  //   if(deliv == 'pickup'){
  //     this.setEmptyAddress()
  //   }else{
  //     const token = localStorage.getItem('bbq_token')?.toString();
  //     if(token){
  //       this.checkoutFormWithToken.patchValue({
  //         address: this.mainAddress.address,
  //         longitude: this.mainAddress.longitude,
  //         latitude: this.mainAddress.latitude
  //       })
  //     }
  //   }
  //   const number = this.phoneNumber.replace(/\D/g, '');
  //   this.checkoutFormWithToken.patchValue({
  //     deliveryNote: this.note,
  //     deliveryPhone: number,
  //     copon_id: localStorage.getItem('couponId'),
  //   })
  //   // this.mainAddress = this.mainAddress.map( address => address.isMain == true )
  //   // console.log(this.mainAddress)
    
  //   this.informationDetailsForm.markAllAsTouched();

  //   // this.isLoadingPlaceOrder = true
  //   if(this.paymentMethod == 'cash' || this.paymentMethod == 'Cash'){
  //     this.placeOrderWithCash()
  //   }else{
  //     try {
  //       const [month, year] = this.paymentData.expirationDate.split('/');
  //       const opaqueData = await this.paymentService.getPaymentNonce({
  //         cardNumber: this.paymentData.cardNumber,
  //         cardCode: this.paymentData.cardCode,
  //         month,
  //         year,
  //         cardHolderName: this.paymentData.cardHolderName
  //       });
  
  //       // Now send the opaqueData to your backend or API
  //       // console.log('Payment Nonce:', opaqueData);
  //       const amount = this.totalCart.toFixed(3).toString();
  //       // console.log('amount:', amount);
  //       const payload = {
  //         createTransactionRequest: {
  //           merchantAuthentication: {
  //             name: '8kPp46H4Ac9',
  //             transactionKey: '55MBn6cA25tqn725'
  //           },
  //           refId: Date.now().toString(),
  //           transactionRequest: {
  //             transactionType: 'authCaptureTransaction',
  //             amount: amount,
  //             payment: {
  //               opaqueData: {
  //                 dataDescriptor: opaqueData.dataDescriptor,
  //                 dataValue: opaqueData.dataValue
  //               }
  //             },
  //             billTo: {
  //               firstName: this.paymentData.cardHolderName.split(' ')[0],
  //               lastName: this.paymentData.cardHolderName.split(' ')[1],
  //               address: this.paymentData.billingAddress,
  //               // city: 'Bayonne',
  //               // state: 'NJ',
  //               // zip: '07002',
  //               // country: 'US'
  //             },
  //             shipTo: {
  //               firstName: this.paymentData.cardHolderName.split(' ')[0],
  //               lastName: this.paymentData.cardHolderName.split(' ')[1],
  //               address: this.paymentData.billingAddress,
  //               // city: 'Bayonne',
  //               // state: 'NJ',
  //               // zip: '07002',
  //               // country: 'US'
  //             },
  //             customerIP: '192.168.1.1'
  //           }
  //         }
  //       };
  //       this.apiService.paymentMethod(payload).subscribe({
  //         next: (response: any) => {
  //           // Check if transactionResponse exists and has the necessary properties
  //           if (!response?.transactionResponse) {
  //             this.handlePaymentError('Invalid response structure', response);
  //             return;
  //           }
  
  //           const transaction = response.transactionResponse;
            
  //           // Check if there are errors and the first error exists
  //           const hasErrors = transaction.errors && transaction.errors.length > 0;
  //           const hasMessages = transaction.messages && transaction.messages.length > 0;
            
  //           const errorCode = hasErrors ? transaction.errors[0].errorCode : null;
  //           const messageCode = hasMessages ? transaction.messages[0].code : null;
            
  //           if (errorCode === '1' || messageCode === '1') {
  //             this.handlePaymentSuccess();
  //           } else {
  //             const errorMessage = hasErrors 
  //               ? transaction.errors[0].errorText 
  //               : 'Unknown payment error';
  //             this.handlePaymentFailure(errorMessage, response);
  //           }
  //         },
  //         error: (error: any) => {
  //           this.alertService.danger('Payment failed');
  //           console.error('HTTP Error:', error);
  //           this.isLoadingPlaceOrder = false;
  //         }
  //       });
  //     } catch (err) {
  //       this.alertService.danger(err);
  //     }
  //   }
  // }

  paymentSuccess: boolean = false;
  // async submitPaymentAsGuest() {
  //   this.isLoadingPlaceOrder = true
  //   const deliv = localStorage.getItem('deliveryOption');
  //   if(deliv == 'pickup'){
  //     this.setEmptyAddress()
  //   }
  //   this.checkoutFormWithoutToken.patchValue({
  //     deliveryNote: this.informationDetailsForm.get('note')?.value,
  //     deliveryPhone: this.informationDetailsForm.get('phoneNumber')?.value,
  //     fullname: this.informationDetailsForm.get('fullname')?.value,
  //     email: this.informationDetailsForm.get('email')?.value,
  //     copon_id: localStorage.getItem('couponId'),
  //     address: this.addressForm.get('address')?.value,
  //     longitude: this.addressForm.get('longitude')?.value,
  //     latitude: this.addressForm.get('latitude')?.value,
  //     deliveryMethod: localStorage.getItem('deliveryOption')
  //   })
    
  //   // this.isLoadingPlaceOrder = true
  //   console.log(this.checkoutFormWithoutToken.value)
  //   if(this.paymentMethod == 'cash' || this.paymentMethod == 'Cash'){
  //     this.placeOrderWithoutTokenWithCash()
  //   }else{
  //     if(this.checkoutFormWithoutToken.valid && this.addressForm.valid){
  //       this.isLoadingPlaceOrder = true
  //       // console.log(this.checkoutFormWithoutToken.value)
  //       try {
  //         const [month, year] = this.paymentData.expirationDate.split('/');
  //         const opaqueData = await this.paymentService.getPaymentNonce({
  //           cardNumber: this.paymentData.cardNumber,
  //           cardCode: this.paymentData.cardCode,
  //           month,
  //           year,
  //           cardHolderName: this.paymentData.cardHolderName
  //         });
    
  //         // Now send the opaqueData to your backend or API
  //         // console.log('Payment Nonce:', opaqueData);
  //         const amount = this.totalCart.toFixed(3).toString();
  //         // console.log('amount:', amount);
  //         const payload = {
  //           createTransactionRequest: {
  //             merchantAuthentication: {
  //               name: '8kPp46H4Ac9',
  //               transactionKey: '55MBn6cA25tqn725'
  //             },
  //             refId: Date.now().toString(),
  //             transactionRequest: {
  //               transactionType: 'authCaptureTransaction',
  //               amount: amount,
  //               payment: {
  //                 opaqueData: {
  //                   dataDescriptor: opaqueData.dataDescriptor,
  //                   dataValue: opaqueData.dataValue
  //                 }
  //               },
  //               billTo: {
  //                 firstName: this.paymentData.cardHolderName.split(' ')[0],
  //                 lastName: this.paymentData.cardHolderName.split(' ')[1],
  //                 address: this.paymentData.billingAddress,
  //                 // city: 'Bayonne',
  //                 // state: 'NJ',
  //                 // zip: '07002',
  //                 // country: 'US'
  //               },
  //               shipTo: {
  //                 firstName: this.paymentData.cardHolderName.split(' ')[0],
  //                 lastName: this.paymentData.cardHolderName.split(' ')[1],
  //                 address: this.paymentData.billingAddress,
  //                 // city: 'Bayonne',
  //                 // state: 'NJ',
  //                 // zip: '07002',
  //                 // country: 'US'
  //               },
  //               customerIP: '192.168.1.1'
  //             }
  //           }
  //         };
  //         // this.placeOrderWithoutToken()
  //         // if(this.paymentSuccess){
  //         this.apiService.paymentMethod(payload).subscribe({
  //           next: (response: any) => {
  //             // Check if transactionResponse exists and has the necessary properties
  //             if (!response?.transactionResponse) {
  //               this.handlePaymentError('Invalid response structure', response);
  //               return;
  //             }

  //             const transaction = response.transactionResponse;
              
  //             // Check if there are errors and the first error exists
  //             const hasErrors = transaction.errors && transaction.errors.length > 0;
  //             const hasMessages = transaction.messages && transaction.messages.length > 0;
              
  //             const errorCode = hasErrors ? transaction.errors[0].errorCode : null;
  //             const messageCode = hasMessages ? transaction.messages[0].code : null;
              
  //             if (errorCode === '1' || messageCode === '1') {
  //               this.handlePaymentSuccess();
  //             } else {
  //               const errorMessage = hasErrors 
  //                 ? transaction.errors[0].errorText 
  //                 : 'Unknown payment error';
  //               this.handlePaymentFailure(errorMessage, response);
  //             }
  //           },
  //           error: (error: any) => {
  //             this.alertService.danger('Payment failed');
  //             console.error('HTTP Error:', error);
  //             this.isLoadingPlaceOrder = false;
  //           }
  //         });
  //         // }else{
  //         //   this.placeOrderWithoutToken()
  //         // }
  //       } catch (err) {
  //         this.alertService.danger(err);
  //         this.isLoadingPlaceOrder = false
  //       }
  //     }else{
  //       this.isLoadingPlaceOrder = false
  //       // console.log(this.checkoutFormWithoutToken.value)
  //       if(this.checkoutFormWithoutToken.get('address')?.value == "" || 
  //       this.checkoutFormWithoutToken.get('longitude')?.value == "" || 
  //       this.checkoutFormWithoutToken.get('latitude')?.value == "" || 
  //       this.checkoutFormWithoutToken.get('deliveryPhone')?.value == "" || 
  //       this.checkoutFormWithoutToken.get('payMethod')?.value == "" || 
  //       this.checkoutFormWithoutToken.get('deliveryMethod')?.value == "" || 
  //       this.addressForm.get('country_id')?.value == "" || this.addressForm.get('city_id')?.value == ""){
  //         this.alertService.danger('Please fill all required fields');
  //       }
  //     }
  //   }
  // }

  private handlePaymentSuccess(): void {
    this.alertService.success('Payment successful!');
    setTimeout(() => {
      this.isLoadingPlaceOrder = false;
      if(this.token){
        this.placeOrder()
      }else{
        this.placeOrderWithoutToken()
      }
    }, 1500);
  }

  private handlePaymentFailure(errorMessage: string, response: any): void {
    this.alertService.danger('Payment failed because of: ' + errorMessage);
    this.isLoadingPlaceOrder = false;
    // this.updatePaymentState("failed");
    console.error('Authorize.Net error:', response);
  }

  private handlePaymentError(message: string, response: any): void {
    this.alertService.danger('Payment error: ' + message);
    this.isLoadingPlaceOrder = false;
    console.error('Payment processing error:', response);
  }

  private updatePaymentState(state: string): void {
    this.apiService.updatePaymentState({ payment_state: state }, this.orderId).subscribe({
      next: response => {
        // console.log('Payment state updated:', response);
      }, 
      error: (error: HttpErrorResponse) => {
        // console.log('Error updating payment state:', error);
        this.alertService.danger('Failed to update payment status!');
      }
    });
  }



  private detectCardType(cardNumber: string): string {
    const cleaned = cardNumber.replace(/\D/g, '');
    if (/^4/.test(cleaned)) return 'visa';
    if (/^5[1-5]/.test(cleaned)) return 'mastercard';
    if (/^3[47]/.test(cleaned)) return 'amex';
    return 'unknown';
  }

  private async withRetry<T>(fn: () => Promise<T>, retries = 2): Promise<T> {
    try {
      return await fn();
    } catch (error) {
      if (retries <= 0) throw error;
      await new Promise(resolve => setTimeout(resolve, 1000));
      return this.withRetry(fn, retries - 1);
    }
  }


  // Helper methods
  private isValidExpirationDate(date: string): boolean {
    return /^(0[1-9]|1[0-2])\/?([0-9]{2})$/.test(date);
  }

  private showSuccess(message: string) {
    this.alertService.success(message);
  }

  private showError(message: string) {
    this.alertService.danger(message);
  }

  private resetForm() {
    this.paymentData = {
      cardHolderName: '',
      cardNumber: '',
      expirationDate: '',
      cardCode: '',
      billingAddress: ''
    };
  }

  formatCardNumber(event: Event) {
    const input = event.target as HTMLInputElement;
    let value = input.value.replace(/\D/g, ''); // Remove non-digits
    value = value.replace(/(\d{4})(?=\d)/g, '$1-'); // Add - every 4 digits
    this.paymentData.cardNumber = value.substring(0, 19); // Limit to 16 digits + 3 hyphens
  }

  // Auto-format expiry date (add / after MM)
  formatExpiryDate(event: Event) {
    const input = event.target as HTMLInputElement;
    let value = input.value.replace(/\D/g, ''); // Remove non-digits
    
    if (value.length > 2) {
      value = value.substring(0, 2) + '/' + value.substring(2, 4); // Add / after MM
    }
    
    this.paymentData.expirationDate = value.substring(0, 5); // Limit to MM/YY
  }

  formatPhoneInput(event: any): void {
    let value = event.target.value.replace(/\D/g, '');
    if (value.length > 3) {
      value = value.substring(0, 3) + '-' + value.substring(3, 6);
    }
    if (value.length > 7) {
      value = value.substring(0, 7) + '-' + value.substring(7, 11);
    }
    event.target.value = value;
    this.phoneNumber = value;
  }


  getUniqueExtrasWithCount(item: any): any[] {
    if (!item || !item.selectedExtraId || !Array.isArray(item.selectedExtraId)) {
        return [];
    }
    
    // Handle both number array and object array formats
    let processedExtras: any[] = [];
    
    if (typeof item.selectedExtraId[0] === 'number') {
        // Format: [30, 30, 34, 34] - count duplicates
        const countMap = new Map<number, number>();
        item.selectedExtraId.forEach((id: number) => {
            countMap.set(id, (countMap.get(id) || 0) + 1);
        });
        
        countMap.forEach((count, id) => {
            const extraInfo = this.getExtraInfo(item, id);
            if (extraInfo) {
                processedExtras.push({
                    id: id,
                    name: extraInfo.name,
                    count: count
                });
            }
        });
    } else {
        // Format: [{id: 30, name: "Yellow Rice", ...}, {id: 34, name: "Coleslaw", ...}]
        const countMap = new Map<number, number>();
        item.selectedExtraId.forEach((extraObj: any) => {
            const id = extraObj.id;
            countMap.set(id, (countMap.get(id) || 0) + 1);
        });
        
        countMap.forEach((count, id) => {
            const extraObj = item.selectedExtraId.find((e: any) => e.id === id);
            if (extraObj) {
                processedExtras.push({
                    id: id,
                    name: extraObj.name,
                    count: count
                });
            }
        });
    }
    
    return processedExtras;
}

  // Helper function to get extra info by ID
  getExtraInfo(item: any, extraId: number): any {
      if (!item || !item.extraproducts || !Array.isArray(item.extraproducts)) {
          return null;
      }
      return item.extraproducts.find((e: any) => e.id == extraId) || null;
  }
  getOriginalItemPrice(item: any): number {
      // If item has selectedTypeId, find the matching type price
      if (item.selectedTypeId && item.types?.length) {
          const selectedType = item.types.find(t => t.id === item.selectedTypeId);
          return selectedType?.price || 0;
      }
      // Otherwise use the first type's price or item price
      return item.types?.[0]?.price || item.price || 0;
  }

  getItemPrice(item: any): number {
    const basePrice = this.getOriginalItemPrice(item);
    
    // Calculate extras price using the new selectedExtraId format (objects with quantity)
    let extrasPrice = 0;
    if (item.selectedExtraId && Array.isArray(item.selectedExtraId)) {
        extrasPrice = item.selectedExtraId.reduce((total: number, extra: any) => {
            return total + (extra.price * extra.quantity);
        }, 0);
    }
    
    // Calculate free sides price
    let freeSidesPrice = 0;
    if (item.selectedFreeSides && Array.isArray(item.selectedFreeSides)) {
        freeSidesPrice = item.selectedFreeSides.reduce((total: number, side: any) => {
            return total + (side.price || 0);
        }, 0);
    }
    
    const totalBasePrice = basePrice + extrasPrice + freeSidesPrice;
    
    if (!item.offer) return totalBasePrice;
    
    if (item.offer.type === 'discount') {
        return Math.max(0, totalBasePrice - item.offer.value);
    } 
    else if (item.offer.type === 'percentage') {
        return totalBasePrice * (1 - item.offer.value / 100);
    }
    
    return totalBasePrice;
  }

  // Additional helper function to get the total price for the item (unit price * quantity)
  getItemTotalPrice(item: any): number {
    return this.getItemPrice(item) * item.quantity;
  }
  calculateCartTotals() {
    let subtotal = 0;
    
    this.cartItems.forEach(item => {
        const itemTotal = this.getItemTotalPrice(item);
        subtotal += itemTotal;
    });
    
    this.subtotalCart = subtotal;
    
    // Recalculate the final total with all charges
    this.calculateFinalTotal();
  }

private calculateFinalTotal() {
    // Calculate tax, fees, etc. based on subtotal
    // this.taxAmount = this.subtotalCart * (this.taxAmount || 0); // Example: 8% tax
    // Add other calculations as needed
    
    // this.totalCart = this.subtotalCart + 
    //                 (this.taxAmount || 0) + 
    //                 (this.feeAmount || 0) + 
    //                 (this.tipAmount || 0) + 
    //                 (this.delivery_fees || 0) - 
    //                 (this.discount || 0);
    this.totalCart =  (( this.taxValue * (this.subtotalCart + this.feeValue))/100) + 
                      (this.tipAmount || 0) + 
                      (this.delivery_fees || 0) - 
                      (this.discount || 0) + 
                      (this.feeAmount || 0) + 
                      this.subtotalCart;

    this.checkoutFormWithToken.patchValue({
        totalCost: parseFloat(this.totalCart.toFixed(2)),
        delivery_tips: this.tipAmount || 0
    });

    if(this.isGuestMode){
        this.checkoutFormWithoutToken.patchValue({
            totalCost: parseFloat(this.totalCart.toFixed(2)),
            delivery_tips: this.tipAmount || 0
        });
    }

    // console.log('Cart Totals:', {
    //     subtotal: this.subtotalCart,
    //     tax: this.taxAmount,
    //     tip: this.tipAmount,
    //     delivery: this.delivery_fees,
    //     discount: this.discount,
    //     total: this.totalCart
    // });
}

  // Helper function to get breakdown for debugging
  getPriceBreakdown(item: any): any {
    const basePrice = this.getOriginalItemPrice(item);
    
    let extrasPrice = 0;
    if (item.selectedExtraId && Array.isArray(item.selectedExtraId)) {
        extrasPrice = item.selectedExtraId.reduce((total: number, extra: any) => {
            return total + (extra.price * extra.quantity);
        }, 0);
    }
    
    let freeSidesPrice = 0;
    if (item.selectedFreeSides && Array.isArray(item.selectedFreeSides)) {
        freeSidesPrice = item.selectedFreeSides.reduce((total: number, side: any) => {
            return total + (side.price || 0);
        }, 0);
    }
    
    return {
        base: basePrice,
        extras: extrasPrice,
        freeSides: freeSidesPrice,
        unitTotal: basePrice + extrasPrice + freeSidesPrice,
        itemTotal: (basePrice + extrasPrice + freeSidesPrice) * item.quantity
    };
  }

  removeItem(index: number) {
    const itemId = this.cartItems[index].id;
    const guestMode = sessionStorage.getItem('guestMode');
    const token = localStorage.getItem('bbq_token')?.toString();

    if(token){
      this.apiService.removeCartItem(itemId).subscribe({
        next: () => {
          this.cartItems.splice(index, 1);
          this.cartItemsLength = this.cartItems.length;
          this.getCartItems()
          this.calculateTotals();
          this.alertService.success('Item removed from cart');
        },
        error: (error) => {
          this.alertService.danger(error.error?.message || 'Failed to remove item');
        }
      });
    }else if(guestMode){
      this.cartItems.splice(index, 1);
      this.cartItemsLength = this.cartItems.length;
      this.saveGuestCart();
      this.calculateTotals();
      this.alertService.success('Item removed from cart');
    }else{
      this.alertService.danger('You must be logged in or <a (click)="enableGuestMode()">continue as a guest</a> to view your cart');
    }
  }
  saveGuestCart() {
    const guestCart = this.cartItems.map(item => ({
        id: item.id || item.product_id,
        name: item.name,
        avatar: item.avatar,
        offer: item.offer || null,
        rate: item.rate || 0,
        components: item.components,
        types: item.types,
        extraproducts: item.extraproducts || [],
        selectedTypeId: item.selectedTypeId,
        selectedExtraId: item.selectedExtraId || item.selectedExtraIds || [], // Use selectedExtraId to match backend
        quantity: item.quantity,
        category_name: item.category_name || item.categoryName || 'Menu',
        // Include price for easy access if needed
        price: item.price || this.getOriginalItemPrice(item),
        // Include free sides if available
        side: item.side || [],
        free_side_count: item.free_side_count || item.free_side || 0
    }));
    
    sessionStorage.setItem('cartItems', JSON.stringify(guestCart));
    console.log('Guest cart saved:', guestCart);
  }

  placeOrderWithCash(){
    if(this.deliveyOption == 'pickup'){
      this.setEmptyAddress()
    }
    const number = this.phoneNumber.replace(/\D/g, '');
    this.isLoadingPlaceOrder = true
    this.checkoutFormWithToken.patchValue({
      deliveryNote: this.note,
      deliveryPhone: number,
      copon_id: localStorage.getItem('couponId'),
      deliveryMethod: localStorage.getItem('deliveryOption')
    })
    // this.mainAddress = this.mainAddress.map( address => address.isMain == true )
    const token = localStorage.getItem('bbq_token')?.toString();
    if(token){
      this.checkoutFormWithToken.patchValue({
        address: this.mainAddress.address,
        longitude: this.mainAddress.longitude,
        latitude: this.mainAddress.latitude
      })
    }
    this.informationDetailsForm.markAllAsTouched();
    // console.log(this.checkoutFormWithToken.value)
    if(this.checkoutFormWithToken.valid){
      this.apiService.confirmOrder(this.checkoutFormWithToken.value).subscribe({
        next: (response) => {
          this.orderId = response.data.id;
          this.alertService.success(response.message);
          // localStorage.removeItem('couponId');
          // localStorage.removeItem('couponType');
          // localStorage.removeItem('couponValue');
          // localStorage.removeItem('couponCode');

          // this.updatePaymentState("success");
          // this.apiService.emptyCart().subscribe({});
          // this.cartItems = [];
          this.router.navigate(['/order-success']);
        }, 
        error: (error) => {
          this.alertService.danger(error.error.message);
          this.isLoadingPlaceOrder = false
        }
      });
    }else{
      if(this.checkoutFormWithoutToken.get('address')?.value == "" || 
        this.checkoutFormWithoutToken.get('longitude')?.value == "" || 
        this.checkoutFormWithoutToken.get('latitude')?.value == "" || 
        this.checkoutFormWithoutToken.get('deliveryPhone')?.value == "" || 
        this.checkoutFormWithoutToken.get('payMethod')?.value == "" || 
        this.checkoutFormWithoutToken.get('deliveryMethod')?.value == "" || 
        this.addressForm.get('country_id')?.value == "" || 
        this.addressForm.get('city_id')?.value == ""){
          this.alertService.danger('Please fill all required fields');
      }
      this.isLoadingPlaceOrder = false
    }
  }
  placeOrderWithoutTokenWithCash(){
    this.isLoadingPlaceOrder = true
    if(this.deliveyOption == 'pickup'){
      this.setEmptyAddress()
    }
    this.checkoutFormWithoutToken.patchValue({
      deliveryNote: this.informationDetailsForm.get('note')?.value,
      deliveryPhone: this.informationDetailsForm.get('phoneNumber')?.value,
      fullname: this.informationDetailsForm.get('fullname')?.value,
      email: this.informationDetailsForm.get('email')?.value,
      copon_id: localStorage.getItem('couponId'),
      address: this.addressForm.get('address')?.value,
      longitude: this.addressForm.get('longitude')?.value,
      latitude: this.addressForm.get('latitude')?.value,
      deliveryMethod: localStorage.getItem('deliveryOption')
    })
    console.log(this.checkoutFormWithoutToken.value)
    if( this.isGuestMode && this.checkoutFormWithoutToken.valid ){
        this.apiService.confirmOrderWithoutToken(this.checkoutFormWithoutToken.value).subscribe({
          next: (response) => {
            this.orderId = response.data.id;
            this.alertService.success(response.message);
            this.dataSubmittedSuccessfully = true;
            // localStorage.removeItem('couponId');
            // localStorage.removeItem('couponType');
            // localStorage.removeItem('couponValue');
            // localStorage.removeItem('couponCode');
            // this.updatePaymentState("success");
            // this.apiService.emptyCart().subscribe({});
            // sessionStorage.removeItem('cartItems');
            // this.cartItems = [];
            this.router.navigate([`/order-success`]);
            // this.submitPaymentAsGuest();
          }, 
          error: (error) => {
            this.dataSubmittedSuccessfully = false;
            this.alertService.danger(error.error.message);
            this.isLoadingPlaceOrder = false
          }
        });
    }else{
      if(this.checkoutFormWithoutToken.get('address')?.value == "" || 
        this.checkoutFormWithoutToken.get('longitude')?.value == "" || 
        this.checkoutFormWithoutToken.get('latitude')?.value == "" || 
        this.checkoutFormWithoutToken.get('deliveryPhone')?.value == "" || 
        this.checkoutFormWithoutToken.get('payMethod')?.value == "" || 
        this.checkoutFormWithoutToken.get('deliveryMethod')?.value == "" || 
        this.addressForm.get('country_id')?.value == "" || 
        this.addressForm.get('city_id')?.value == ""){
          this.alertService.danger('Please fill all required fields');
      }
      this.isLoadingPlaceOrder = false
    }
  }
}
